import { Dispatch } from '@reduxjs/toolkit'
import { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import { ApiCache } from '@redux/queries/apiCache'
import { claimRecordsApi } from '@redux/queries/claimRecords'
import { configApi } from '@redux/queries/config'
import { insurersApi } from '@redux/queries/insurers'
import { resetClaimStatusInitialState } from '@redux/slices/claimStatusSlice'
import { connectorLogoutInProgress } from '@redux/slices/connectorSlice'
import { resetCtaInitialState } from '@redux/slices/ctaSlice'
import { resetInsuranceMemberState } from '@redux/slices/insuranceMemberSlice'
import { resetWorkflowInitialState } from '@redux/slices/workflowSlice'

export const useLogoutEventHandler = (): (() => void) => {
  const dispatch = useDispatch()
  const [isInProgress, setIsInProgress] = useState(false)

  return useCallback(async () => {
    if (isInProgress) return

    setIsInProgress(true)

    try {
      resetState(dispatch)
      await ApiCache.cleanupCache()
    } finally {
      setIsInProgress(false)
    }
  }, [dispatch, isInProgress])
}

const resetState = (dispatch: Dispatch) => {
  dispatch(claimRecordsApi.util.resetApiState())
  dispatch(configApi.util.resetApiState())
  dispatch(insurersApi.util.resetApiState())

  dispatch(resetCtaInitialState())
  dispatch(resetWorkflowInitialState())
  dispatch(resetInsuranceMemberState())
  dispatch(resetClaimStatusInitialState())

  dispatch(connectorLogoutInProgress())
}
